import { FC, useEffect, useState } from 'react';
import { useGetOrderStatusQuery } from '@services';
import { SuccessView, OtherView, PendingView, TimedOutView } from './ConfirmModalViews';
import { useAppSelector } from '@hooks/redux-custom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
};

let statusPolling: ReturnType<typeof setInterval>;
let pollingIterations = 0;

export const OrderStatusModal: FC<Props> = ({ isOpen, onClose, orderId }) => {
  const [currentModalState, setCurrentModalState] = useState('');
  const orderStatuses = useAppSelector((state) => state.order.value.orderStatus);
  const { data: currentOrderStatusId, refetch } = useGetOrderStatusQuery({
    orderId: orderId,
  });

  clearInterval(statusPolling);

  const getOrderStatus = () => orderStatuses.find((order: { id: number | undefined }) => order.id === currentOrderStatusId);

  statusPolling = setInterval(() => {
    pollingIterations++;

    refetch();

    if (pollingIterations > 10 && getOrderStatus()?.name !== 'Declined') {
      setCurrentModalState('Timed Out');
      pollingIterations = 0;
    } else {
      clearInterval(statusPolling);
    }
  }, 5000);

  useEffect(() => {
    if (currentOrderStatusId === 11) {
      setCurrentModalState('Awaiting Fulfillment');
      clearInterval(statusPolling);
    } else if (currentOrderStatusId && currentOrderStatusId !== 7) {
      // if not pending move to other state
      setCurrentModalState('Other');
      clearInterval(statusPolling);
    }
  }, [currentOrderStatusId]);

  const getModalState = () => {
    switch (currentModalState) {
      case 'Awaiting Fulfillment':
        return <SuccessView isOpen={isOpen} onClose={onClose} />;
      case 'Other':
        return (
          <OtherView isOpen={isOpen} onClose={onClose} setCurrentModalState={setCurrentModalState} orderStatus={getOrderStatus()?.name} />
        );
      case 'Timed Out':
        return <TimedOutView isOpen={isOpen} onClose={onClose} />;
      default:
        return <PendingView isOpen={isOpen} onClose={onClose} />;
    }
  };

  return <>{getModalState()}</>;
};
